/**
 * Catch-all 404 inside the gated shell.
 */
import { Link } from 'react-router-dom';
import { useCopy } from '@/hooks/useCopy';
import { useDocumentTitle } from '@/hooks/useDocumentTitle';

export function NotFound() {
  const { t } = useCopy();
  useDocumentTitle(t('notFound.title', 'Not found'));
  return (
    <section>
      <h1>{t('notFound.title', 'Not found')}</h1>
      <p>{t('notFound.body', 'That page doesn’t exist.')}</p>
      <Link to="/">{t('notFound.home', 'Go home')}</Link>
    </section>
  );
}
